// extracted by mini-css-extract-plugin
export var Title = "styles-module--Title--bXbF6";